import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from 'vuex';
import { RcSection } from '@components/RcSection';
import LabeledSelect from '@shell/components/form/LabeledSelect';
import { useI18n } from '@shell/composables/useI18n';
import type { FleetPolicyNameOption } from '@shell/types/fleet';

/**
 * The nested panel a Fleet Policy section reveals once the user restricts a set of
 * names (service accounts, client secrets, Helm secrets) rather than allowing all.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'FleetPolicyAllowList',
  props: {
    value: {},
    title: {},
    label: {},
    options: { default: () => [] },
    mode: {},
    dataTestid: {}
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n(useStore());

const update = (value: string[]) => emit('update:value', value || []);

// Secrets are offered as options carrying a label, so a name typed in has to be shaped the same
// way, or the select hands back the option object instead of the name the policy stores
const createOption = (name: string) => ({ label: name, value: name });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RcSection), {
    title: props.title,
    mode: "with-header",
    type: "secondary",
    expandable: "",
    "data-testid": `${ props.dataTestid }-section`
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(LabeledSelect), {
        value: props.value,
        options: props.options,
        label: props.label,
        placeholder: _unref(t)('fleet.policy.placeholder.allowList'),
        mode: props.mode,
        multiple: true,
        taggable: true,
        searchable: true,
        "close-on-select": false,
        "create-option": createOption,
        required: true,
        "data-testid": props.dataTestid,
        "onUpdate:value": update
      }, null, 8, ["value", "options", "label", "placeholder", "mode", "data-testid"])
    ]),
    _: 1
  }, 8, ["title", "data-testid"]))
}
}

})